import { type CountryCode } from '@constants'
import { type CountryCode as PhoneCountryCode } from 'libphonenumber-js'
import { type BillingBaseStore } from '../types'

export const setBillingAddressAddress1 = (state: BillingBaseStore, billingAddressAddress1: string): BillingBaseStore => {
  return {
    ...state,
    billingAddressAddress1,
  }
}

export const setBillingAddressAddress2 = (state: BillingBaseStore, billingAddressAddress2: string): BillingBaseStore => {
  return {
    ...state,
    billingAddressAddress2,
  }
}

export const setBillingAddressCity = (state: BillingBaseStore, billingAddressCity: string): BillingBaseStore => {
  return {
    ...state,
    billingAddressCity,
  }
}

export const setBillingAddressEmail = (state: BillingBaseStore, billingAddressEmail: string): BillingBaseStore => {
  return {
    ...state,
    billingAddressEmail,
  }
}

export const setBillingAddressFirstName = (state: BillingBaseStore, billingAddressFirstName: string): BillingBaseStore => {
  return {
    ...state,
    billingAddressFirstName,
  }
}

export const setBillingAddressPhone = (state: BillingBaseStore, billingAddressPhone: string): BillingBaseStore => {
  return {
    ...state,
    billingAddressPhone,
  }
}

export const setBillingAddressPhoneCountry = (state: BillingBaseStore, billingAddressPhoneCountry: PhoneCountryCode | null): BillingBaseStore => {
  return {
    ...state,
    billingAddressPhoneCountry,
  }
}

export const setBillingAddressPostcode = (state: BillingBaseStore, billingAddressPostcode: string): BillingBaseStore => {
  return {
    ...state,
    billingAddressPostcode,
  }
}

export const setBillingAddressState = (state: BillingBaseStore, billingAddressState: string): BillingBaseStore => {
  return {
    ...state,
    billingAddressState,
  }
}

export const setBillingCountry = (state: BillingBaseStore, billingCountry: CountryCode): BillingBaseStore => {
  return {
    ...state,
    billingCountry,
  }
}

export const setCustomerNote = (state: BillingBaseStore, customerNote: string): BillingBaseStore => {
  return {
    ...state,
    customerNote,
  }
}
